import * as React from "react";
import LockIcon from "@material-ui/icons/Lock";
import Tooltip from "@material-ui/core/Tooltip";

class LockComponent extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  public render() {
    const value = this.props.dataItem.checkOutBy;
    const isLocked = value ? true : false;
    const checkoutMessage = `Case is checked out by ${value}`;
    return (
      <td>
        {isLocked ? (
          <div style={{ paddingTop: "10px" }}>
            <Tooltip title={checkoutMessage}>
              <LockIcon style={{ fontSize: "18px" }} />
            </Tooltip>
          </div>
        ) : (
          <span />
        )}
      </td>
    );
  }
}

export default LockComponent;
